import { BillingCoefficients } from './../../../../customers/shared/model/customer.model';
import {Pagination} from '../pagination.model';

export class BillingCoefficientsPage  extends Pagination {
  content: BillingCoefficients[] = [];
}
